module.exports = __webpack_public_path__ + "static/assets/cde8b1328a70ea513705a7bb07bfbc9d.svg";